import React from 'react'
import { connect } from 'react-redux'
import filter from 'lodash/filter'
import find from 'lodash/find'
import sortBy from 'lodash/sortBy'
import { getImageUrl } from '@plickers/now-player-library/renderer'
import Icon from '../../misc/Icons'
import { formatDate } from '../../../utils/formatDate'
import SearchPreviewChildList from './SearchPreviewChildList'

function SearchPreviewPack({
  hit, sets, folders, questions, storePack,
}) {
  const pack = storePack || hit
  const editedAt = pack && pack.clientModified

  const coverImageUrl = pack && pack.image ?
    getImageUrl(pack.id, { version: pack.image, folderPath: '/repo', format: 'jpg' }) :
    null

  return (
    <div className='searchPreviewPane searchPreviewPane--pack'>
      <div className='searchPreviewPane-header'>
        {coverImageUrl ? (
          <div className='searchPreviewPane-header-coverImage'>
            <img src={coverImageUrl} alt={pack.name || 'Pack cover'} />
          </div>
        ) : (
          <div className='searchPreviewPane-header-icon'>
            <Icon name='search-pack' />
          </div>
        )}
        <div className='searchPreviewPane-header-text'>
          <div className='searchPreviewPane-header-title'>
            {(pack && pack.name) || 'Untitled Pack'}
          </div>
          {pack && pack.description && (
            <div className='searchPreviewPane-header-description'>
              {pack.description}
            </div>
          )}
          {pack && pack.rating > 0 && (
            <div className='searchPreviewPane-header-meta'>
              <span>{`★ ${Math.round(pack.rating * 10) / 10}`}</span>
            </div>
          )}
          {editedAt && (
            <div className='searchPreviewPane-header-subtitle'>
              {'Edited '}
              {formatDate(editedAt)}
            </div>
          )}
        </div>
      </div>
      <div className='searchPreviewPane-body searchPreviewPack'>
        <SearchPreviewChildList
          folders={folders}
          sets={sets}
          questions={questions}
          emptyLabel='Pack has no content'
        />
      </div>
    </div>
  )
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.hit && ownProps.hit.id
  if (!id) {
    return {
      sets: [], folders: [], questions: [], storePack: null,
    }
  }
  const setsInPack = sortBy(
    filter(state.sets, (s) => s && s.repo === id && !s.archived),
    (s) => -((s.clientModified && new Date(s.clientModified).getTime()) || 0),
  )
  const foldersInPack = sortBy(
    filter(state.folders, (f) => f && f.repo === id && !f.archived && !f.parent),
    'name',
  )
  // Standalone questions sitting at the pack root (not inside a folder).
  const questionsInPack = sortBy(
    filter(state.questions, (q) => q && q.repo === id && !q.folder && !q.archived),
    (q) => -((q.clientModified && new Date(q.clientModified).getTime()) || 0),
  )
  return {
    sets: setsInPack,
    folders: foldersInPack,
    questions: questionsInPack,
    storePack: find(state.repos, { id }),
  }
}

export default connect(mapStateToProps)(SearchPreviewPack)
